import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import MultiSelectBox from '../../../../../../../features/components/Form/MultiSelectBox'

import { formatOptionsList } from '../../../../../../../features/formatters'

import {
  choicesBehavioursSelector,
  getChoicesBehavioursIsLoadingSelector
} from '../../../../../../../modules/selectors/choices'
import { clearGetChoicesBehaviours, getChoicesBehaviours } from '../../../../../../../modules/actions/choices'
import { selectedFacebookAdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'

import { BEHAVIORS } from './fields'

const BehavioursSelect = ({ formik }) => {
  const { values, setFieldValue } = formik
  const dispatch = useDispatch()

  const getChoicesBehavioursIsLoading = useSelector(getChoicesBehavioursIsLoadingSelector)
  const choicesBehaviours = useSelector(choicesBehavioursSelector)
  const { id: selectedAdAccountId } = useSelector(selectedFacebookAdAccountSelector)

  const formattedBehaviours = useMemo(() => {
    return formatOptionsList({
      list: choicesBehaviours,
      labelName: 'name',
      valueName: 'id'
    })
  }, [choicesBehaviours])

  const searchBehaviours = useCallback(
    searchValue => {
      if (searchValue) {
        dispatch(getChoicesBehaviours({ search: searchValue, account: selectedAdAccountId }))
      } else {
        dispatch(clearGetChoicesBehaviours())
      }
    },
    [dispatch, selectedAdAccountId]
  )

  return (
    <MultiSelectBox
      name={BEHAVIORS}
      options={formattedBehaviours}
      value={values[BEHAVIORS]}
      isLoading={getChoicesBehavioursIsLoading}
      onSearch={searchBehaviours}
      setFieldValue={setFieldValue}
    />
  )
}

export default BehavioursSelect
